/* Premier Catering Supplies — collection spec filters (26-9-2026; single price per card 27-9-2026).
   Diameter / Capacity / Material / Colour / Pack size across the WHOLE collection (all pages), on top of the
   server filters (tags, price, availability, sort). Data from assets/pcl-facet-data.js. Every option shows its
   live count; options with no products are hidden, so a choice can never lead to an empty page.
   State lives in the URL hash (#dia=…&mat=…&pg=2) so the homepage product finder can deep-link here. */
(function () {
  'use strict';
  var root = document.querySelector('[data-pcl-collection]');
  if (!root || !window.PCLData) return;
  var D = window.PCLData;
  var results = root.querySelector('[data-pcl-results]');
  var perPage = +root.getAttribute('data-per-page') || 36;
  var maxAuto = 4000;
  var state = D.parseHash(window.location.hash);
  var page = state.pg || 1; delete state.pg;
  var data = null, dataUrl = null, loading = null;
  var openState = {};
  var snapshot = null, snapshotUrl = null, replaced = false;

  function qs(s, c) { return (c || root).querySelector(s); }
  function qsa(s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function active() { for (var k in state) if (state[k] && state[k].length) return true; return false; }
  function serverUrl() { return window.location.pathname + window.location.search; }
  /* matching total from the toolbar text: "Showing 1–36 of 750" or "120 of 750 match" */
  function total() {
    var c = results && results.querySelector('[data-pcl-count]');
    if (!c) return 0;
    var txt = c.textContent.replace(/,/g, '');
    var nums = txt.match(/\d+/g) || [];
    if (/match/.test(txt)) return +nums[0] || 0;
    return +nums[nums.length - 1] || 0;
  }
  function writeHash() {
    var h = D.toHash(Object.assign({ pg: page }, state));
    history.replaceState(history.state, '', window.location.pathname + window.location.search + h);
  }

  /* ---------- data ---------- */
  function ensureData() {
    var url = serverUrl();
    if (data && dataUrl === url) return Promise.resolve(data);
    if (loading && loading.url === url) return loading.p;
    var p = D.load(url).then(function (d) { data = d; dataUrl = url; return d; });
    loading = { url: url, p: p };
    return p;
  }

  /* ---------- facet panel ---------- */
  function box() {
    var host = qs('[data-pfc-facets]');
    if (host) return host;
    var form = qs('[data-pcl-form]');
    if (!form) return null;
    host = document.createElement('div');
    host.className = 'pfc-host';
    host.setAttribute('data-pfc-facets', '');
    var after = form.querySelector('[data-pcl-facet="type"]') || form.querySelector('.pcl-active');
    if (after) after.parentNode.insertBefore(host, after.nextSibling);
    else form.insertBefore(host, form.querySelector('.pcl-facet, .pcl-filters__foot'));
    return host;
  }
  function renderFacets() {
    var host = box();
    if (!host) return;
    if (!data) { host.innerHTML = '<p class="pfc-loading">Loading size, material and colour filters…</p>'; return; }
    var items = data.items;
    var html = '';
    var pills = [];
    D.defs().forEach(function (f) {
      var values = f.key === 'pack' ? D.packValues(items) : f.values;
      var cnt = D.counts(items, state, f.key);
      var sel = state[f.key] || [];
      var shown = values.filter(function (v) { return cnt[v.k] || sel.indexOf(v.k) > -1; });
      shown.forEach(function (v) { if (sel.indexOf(v.k) > -1) pills.push({ key: f.key, v: v }); });
      if (shown.length < 2 && !sel.length) return;
      var open = f.key in openState ? openState[f.key] : true;
      html += '<details class="pcl-facet pfc-facet" data-pcl-facet="pfc-' + f.key + '"' + (open ? ' open' : '') + '>' +
        '<summary class="pcl-facet__sum"><span>' + f.label + (f.key === 'pack' ? ' <small>pieces per pack</small>' : '') + '</span>' +
        (sel.length ? '<em class="pcl-facet__badge">' + sel.length + '</em>' : '') +
        '<svg class="pcl-facet__chev" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg></summary><div class="pcl-facet__body">';
      if (f.type === 'checks') {
        html += '<ul class="pcl-facet__list">' + shown.map(function (v) {
          var on = sel.indexOf(v.k) > -1;
          return '<li><label class="pcl-check"><input type="checkbox" data-pfc="' + f.key + '" value="' + v.k + '"' + (on ? ' checked' : '') + '><span class="pcl-check__box" aria-hidden="true"></span><span class="pcl-check__label">' + esc(v.label) + '</span><span class="pcl-check__count">' + (cnt[v.k] || 0) + '</span></label></li>';
        }).join('') + '</ul>';
      } else if (f.type === 'swatches') {
        html += '<div class="pfc-swatches" role="group" aria-label="' + f.label + '">' + shown.map(function (v) {
          var on = sel.indexOf(v.k) > -1;
          return '<button type="button" class="pfc-sw' + (on ? ' is-on' : '') + (v.k === 'white' ? ' is-light' : '') + (v.k === 'clear' ? ' is-clear' : '') + '" style="--sw:' + v.sw + '" data-pfc="' + f.key + '" data-v="' + v.k + '" aria-pressed="' + on + '" title="' + esc(v.label) + ' (' + (cnt[v.k] || 0) + ')"><span class="pcl-sr">' + esc(v.label) + ', ' + (cnt[v.k] || 0) + ' products</span></button>';
        }).join('') + '</div>' +
        (sel.length ? '<p class="pfc-sw-names">' + sel.map(function (k) { var v = f.values.filter(function (x) { return x.k === k; })[0]; return v ? esc(v.label) : ''; }).join(', ') + '</p>' : '');
      } else {
        html += '<div class="pfc-chips" role="group" aria-label="' + f.label + '">' + shown.map(function (v) {
          var on = sel.indexOf(v.k) > -1;
          return '<button type="button" class="pfc-chip' + (on ? ' is-on' : '') + '" data-pfc="' + f.key + '" data-v="' + v.k + '" aria-pressed="' + on + '">' + esc(v.label) + '<small>' + (cnt[v.k] || 0) + '</small></button>';
        }).join('') + '</div>';
      }
      html += '</div></details>';
    });
    var top = '';
    if (pills.length) {
      top = '<div class="pfc-pills" aria-label="Selected size, material and colour filters">' + pills.map(function (p) {
        return '<button type="button" class="pcl-active__pill" data-pfc-rm="' + p.key + '" data-v="' + p.v.k + '">' + esc(p.v.label) + (p.key === 'pack' ? (p.v.k === '1' ? '' : ' per pack') : '') + ' <span aria-hidden="true">×</span><span class="pcl-sr">Remove filter</span></button>';
      }).join('') + '<button type="button" class="pfc-clear" data-pfc-clear>Clear these</button></div>';
    }
    host.innerHTML = top + html;
  }

  /* ---------- results ---------- */
  function specsOf(it) {
    var s = '';
    if (it.c) { s += '<div><dt>Capacity</dt><dd>' + it.c + 'ml</dd></div>'; }
    if (it.d) { s += '<div><dt>' + esc(it.dl || 'Diameter') + '</dt><dd>' + it.d + 'mm</dd></div>'; }
    if (it.m) { s += '<div><dt>Material</dt><dd>' + esc(it.m) + '</dd></div>'; }
    if (it.co) { s += '<div><dt>Colour</dt><dd>' + it.co + '</dd></div>'; }
    if (!s) s = '<div class="pcl-card__specs-none"><dd>See product page for details</dd></div>';
    return s;
  }
  function cmpSpecs(it) {
    var s = '';
    if (it.c) s += 'Capacity:' + it.c + 'ml~~';
    if (it.d) s += (it.dl || 'Diameter') + ':' + it.d + 'mm~~';
    if (it.m) s += 'Material:' + it.m + '~~';
    if (it.co) s += 'Colour:' + String(it.co).replace(/&amp;/g, '&') + '~~';
    return s;
  }
  function card(it, i) {
    var pack = it.k > 1 ? it.k : 0;
    var alt = it.t + (it.m ? ', ' + it.m : '') + (pack ? ', pack of ' + pack : '');
    var h = '<li class="pcl-card' + (it.a ? '' : ' is-soldout') + '" data-pcl-item data-id="' + it.id + '" data-title="' + esc(it.t) + '" data-url="' + esc(it.u) + '" data-img="' + esc(it.i ? it.i.replace(/width=\d+/, 'width=240') : '') + '" data-price="' + esc(it.pm) + '" data-pack="' + pack + '" data-specs="' + esc(cmpSpecs(it)) + '">';
    h += '<div class="pcl-card__media"><a href="' + esc(it.u) + '" class="pcl-card__link" tabindex="-1" aria-hidden="true" data-pcl-product-link>' +
      (it.i ? '<img src="' + esc(it.i) + '" alt="' + esc(alt) + '" class="pcl-card__img" width="600" height="600" loading="' + (i < 8 ? 'eager' : 'lazy') + '">' : '<span class="pcl-card__noimg">No image yet</span>') + '</a>' +
      (pack ? '<span class="pcl-card__pack">Pack of ' + pack + '</span>' : '') + (it.a ? '' : '<span class="pcl-card__badge">Out of stock</span>') + '</div>';
    h += '<div class="pcl-card__body"><h3 class="pcl-card__title"><a href="' + esc(it.u) + '" data-pcl-product-link>' + esc(it.t) + '</a></h3>';
    h += '<dl class="pcl-card__specs">' + specsOf(it) + '</dl>';
    h += '<div class="pcl-card__price"><span class="pcl-card__amount">' + (it.pv ? '<small>From</small> ' : '') + esc(it.pm) + '</span>' +
      (!pack && it.s ? '<span class="pcl-card__per">Sold individually</span>' : '') + '</div>';
    h += '<div class="pcl-card__actions">';
    if (it.a && it.s) {
      h += '<form action="/cart/add" method="post" class="pcl-add" data-pcl-add data-pack="' + pack + '"><input type="hidden" name="id" value="' + it.v + '">' +
        '<div class="pcl-qty"><span class="pcl-qty__label" id="pcl-qty-l-' + it.id + '">' + (pack ? 'Packs' : 'Qty') + '</span>' +
        '<button type="button" class="pcl-qty__btn" data-pcl-qty="-1" aria-label="Decrease ' + (pack ? 'packs' : 'quantity') + '">−</button>' +
        '<input type="number" name="quantity" value="1" min="1" step="1" inputmode="numeric" aria-labelledby="pcl-qty-l-' + it.id + '" data-pcl-qty-input>' +
        '<button type="button" class="pcl-qty__btn" data-pcl-qty="1" aria-label="Increase ' + (pack ? 'packs' : 'quantity') + '">+</button></div>' +
        '<button type="submit" class="pcl-btn pcl-btn--primary pcl-add__btn"><span class="pcl-add__label">Add to basket</span><span class="pcl-add__busy" aria-hidden="true">Adding…</span><span class="pcl-add__done" aria-hidden="true">Added ✓</span></button>' +
        (pack ? '<span class="pcl-add__sum" data-pcl-add-sum aria-live="polite">1 pack · ' + pack + ' pieces</span>' : '') + '</form>';
    } else if (it.a) {
      h += '<a href="' + esc(it.u) + '" class="pcl-btn pcl-btn--ghost">Choose options</a>';
    } else {
      h += '<a href="' + esc(it.u) + '" class="pcl-btn pcl-btn--ghost">View product</a>';
    }
    h += '<label class="pcl-card__cmp"><input type="checkbox" data-pcl-cmp aria-label="Compare ' + esc(it.t) + '"><span class="pcl-card__cmp-box" aria-hidden="true"></span><span class="pcl-card__cmp-txt">Compare</span></label>';
    h += '</div></div></li>';
    return h;
  }
  function pager(pages) {
    if (pages < 2) return '';
    var h = '<nav class="pcl-pages" aria-label="Pagination"><p class="pcl-pages__info">Page ' + page + ' of ' + pages + '</p><div class="pcl-pages__row">';
    h += page > 1 ? '<button type="button" class="pcl-pages__btn" data-pfc-page="' + (page - 1) + '">‹ Previous</button>' : '<span class="pcl-pages__btn is-disabled" aria-disabled="true">‹ Previous</span>';
    h += '<ul>';
    var list = [];
    for (var p = 1; p <= pages; p++) if (p === 1 || p === pages || Math.abs(p - page) <= 1) list.push(p);
    var last = 0;
    list.forEach(function (p) {
      if (last && p - last > 1) h += '<li><span class="is-gap">…</span></li>';
      h += p === page ? '<li><span class="is-current" aria-current="page">' + p + '</span></li>' : '<li><button type="button" data-pfc-page="' + p + '" aria-label="Page ' + p + '">' + p + '</button></li>';
      last = p;
    });
    h += '</ul>';
    h += page < pages ? '<button type="button" class="pcl-pages__btn" data-pfc-page="' + (page + 1) + '">Next ›</button>' : '<span class="pcl-pages__btn is-disabled" aria-disabled="true">Next ›</span>';
    return h + '</div></nav>';
  }
  function renderResults() {
    var list = data.items.filter(function (it) { return D.match(it, state); });
    var pages = Math.max(1, Math.ceil(list.length / perPage));
    if (page > pages) page = pages;
    var start = (page - 1) * perPage;
    var slice = list.slice(start, start + perPage);
    if (!replaced) { snapshot = results.innerHTML; snapshotUrl = serverUrl(); replaced = true; }
    var count = qs('[data-pcl-count]', results);
    if (count) count.innerHTML = '<strong>' + list.length.toLocaleString('en-GB') + '</strong> of ' + data.total.toLocaleString('en-GB') + ' match <span class="pcl-toolbar__range">· showing ' + (list.length ? start + 1 : 0) + '–' + (start + slice.length) + '</span>';
    qsa('.pcl-grid, .pcl-pages, .pcl-empty', results).forEach(function (n) { n.parentNode.removeChild(n); });
    var wrap = document.createElement('div');
    var densityClass = 'pcl-grid--4';
    try { var dv = localStorage.getItem('pcl-density'); if (['3', '4', 'list'].indexOf(dv) > -1) densityClass = 'pcl-grid--' + dv; } catch (e) {}
    wrap.innerHTML = list.length ? '<ul class="pcl-grid ' + densityClass + '" data-pcl-grid>' + slice.map(card).join('') + '</ul>' + pager(pages)
      : '<div class="pcl-empty"><h2>No products match those filters</h2><p>Remove one of the filters to see more of the range.</p><button type="button" class="pcl-btn pcl-btn--primary" data-pfc-clear>Clear size, material &amp; colour filters</button></div>';
    while (wrap.firstChild) results.appendChild(wrap.firstChild);
    syncCompare();
  }
  function syncCompare() {
    var ids = [];
    try { ids = JSON.parse(sessionStorage.getItem('pcl-compare') || '[]').map(function (i) { return i.id; }); } catch (e) {}
    qsa('[data-pcl-item]', results).forEach(function (c) { var b = c.querySelector('[data-pcl-cmp]'); if (b) b.checked = ids.indexOf(c.getAttribute('data-id')) > -1; });
  }
  function restoreServer() {
    if (!replaced) return;
    replaced = false;
    if (snapshot !== null && snapshotUrl === serverUrl()) { results.innerHTML = snapshot; snapshot = null; return; }
    /* server state changed since: let the collection script re-render the current URL */
    var a = document.createElement('a');
    a.href = serverUrl(); a.setAttribute('data-pcl-link', ''); a.hidden = true;
    root.appendChild(a); a.click(); root.removeChild(a);
  }

  function apply(scroll) {
    writeHash();
    if (!data) { renderFacets(); }
    return ensureData().then(function () {
      renderFacets();
      if (active()) renderResults(); else restoreServer();
      if (scroll) {
        var off = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--pcs-sticky-h'), 10) || 124;
        var top = root.getBoundingClientRect().top + window.scrollY - off - 12;
        if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
      }
    }).catch(function () {
      var host = box(); if (host) host.innerHTML = '<p class="pfc-loading">These filters could not load — please refresh the page.</p>';
    });
  }
  function toggle(key, val) {
    var cur = (state[key] || []).slice();
    var i = cur.indexOf(val);
    if (i > -1) cur.splice(i, 1); else cur.push(val);
    state[key] = cur;
    page = 1;
    apply(false);
  }

  /* ---------- events ---------- */
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-pfc]')) { e.stopPropagation(); toggle(t.getAttribute('data-pfc'), t.value); }
  }, true);
  root.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-pfc]');
    if (b) { e.preventDefault(); toggle(b.getAttribute('data-pfc'), b.getAttribute('data-v')); return; }
    var rm = e.target.closest('[data-pfc-rm]');
    if (rm) { e.preventDefault(); toggle(rm.getAttribute('data-pfc-rm'), rm.getAttribute('data-v')); return; }
    if (e.target.closest('[data-pfc-clear]')) { e.preventDefault(); state = {}; page = 1; apply(false); return; }
    var pg = e.target.closest('[data-pfc-page]');
    if (pg) { e.preventDefault(); page = +pg.getAttribute('data-pfc-page') || 1; apply(true); return; }
    /* server "Clear all" also clears these filters */
    if (e.target.closest('.pcl-filters__clear')) { state = {}; page = 1; replaced = false; writeHash(); }
  }, true);
  root.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d.matches && d.matches('.pfc-facet')) openState[d.getAttribute('data-pcl-facet').replace('pfc-', '')] = d.open;
  }, true);

  /* the collection script re-renders filters + results after tag / price / sort / page changes */
  if (window.MutationObserver && results) {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.attributeName !== 'aria-busy' || results.getAttribute('aria-busy') !== 'false') return;
        replaced = false; snapshot = null;
        if (active()) { page = 1; apply(false); } else { writeHash(); if (data && dataUrl === serverUrl()) renderFacets(); else if (total() <= maxAuto) ensureData().then(renderFacets); else renderFacets(); }
      });
    }).observe(results, { attributes: true, attributeFilter: ['aria-busy'] });
  }

  /* ---------- start ---------- */
  if (total() > maxAuto && !active()) {
    var host = box(); if (host) host.innerHTML = '';
    return;
  }
  if (active()) apply(false);
  else {
    renderFacets();
    var go = function () { ensureData().then(renderFacets).catch(function () {}); };
    if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 2500 }); else setTimeout(go, 1200);
  }
})();